import { UserOptionLabel } from "components";
import { getFullName } from "helpers";
import { applicationListService } from "services";
import { FilterColumn } from "types";

const pendedToColumn = ({
	name = "pendedTo",
	placeholder = "Pended To",
} = {}): FilterColumn => ({
	name,
	type: "select" as const,
	placeholder,
	formatLabel: getFullName,
	getOptionLabel: UserOptionLabel,
	getOptionValue: option => option.id,
	loadOptions: async (search, prevOptions, { page }) => {
		try {
			let newUsers = await applicationListService.getAssignedUsers(
				search,
				page,
				true,
			);

			const hasMore =
				prevOptions.length + newUsers.items.length < newUsers.count;

			return {
				options: newUsers.items,
				hasMore,
				additional: {
					page: page + 1,
				},
			};
		} catch {
			return { options: [] };
		}
	},
});

export default pendedToColumn;
